import {createAction} from 'redux-actions';

export const RESET_LOADING = 'LOADING/RESET_LOADING';
export const START_LOADING = 'LOADING/START_LOADING';
export const FINISH_LOADING = 'LOADING/FINISH_LOADING';

export const resetLoading = createAction(RESET_LOADING);
export const startLoading = createAction(START_LOADING);
export const finishLoading = createAction(FINISH_LOADING);
